import { http, ajax, ajaxUrl } from "@/libs/util";
import util from "@/libs/util";
export const {
  SPU_COST_ALLOCATION_QUERY,
  SPU_COST_ALLOCATION_IMPORT,
  SPU_COST_ALLOCATION_DOWNLOAD,
  SPU_COST_ALLOCATION_INFO_QUERY,
} = util.api || {};

export function querySpuCostAllocation(params) {
  return http.get(SPU_COST_ALLOCATION_QUERY, params);
}

export function importSpuCostAllocation(formData, onProgress = () => {}) {
  return new Promise((resolve, reject) => {
    ajax({
      url: ajaxUrl + "/" + SPU_COST_ALLOCATION_IMPORT,
      method: 'post',
      data: formData,
      timeout: 120000,
      onUploadProgress: (e) => {
        const percent = e.loaded / e.total * 100;
        onProgress && onProgress(percent < 0.1 ? 0.1 : percent);
      },
    }).then(response => {
      return response.data;
    }).then(({code, data, msg}) => {
      if (code === 1) {
        resolve(data.records);
      } else {
        reject({message:msg});
      }
    }).catch((e) => {
      reject(e);
    })
  })
}

export function downloadSpuCostAllocation() {
  window.open(ajaxUrl + "/" + SPU_COST_ALLOCATION_DOWNLOAD, "_blank")
}

export function querySpuCostAllocationInfo(params) {
  return http.get(SPU_COST_ALLOCATION_INFO_QUERY, params);
}
